import { IState } from '../../../store';
import { selectOfferAgent } from '../selectOfferAgent';

export const selectAgencyCianId = (state: IState): number | null => {
  const agent = selectOfferAgent(state);

  return agent?.masterAgent?.cianUserId || null;
};
